<template>
  <div>
    <div class="flex text-2xl font-semibold relative">Track your Booking</div>
    <div class="text-base pt-6 relative">
      Enter a booking or reference number
      <div class="tooltip">
        <svg
          class="inline-block fill-current h-4 -mt-1 ml-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.3431 13.657A8 8 0 1113.656 2.343 8 8 0 012.343 13.657zm10.19-1.123a6.401 6.401 0 10-9.069-9.036 6.401 6.401 0 009.069 9.036zM7.199 8.801v-1.6h1.6v4.8H7.2v-3.2zm0-4.8h1.6v1.6H7.2v-1.6z"
          />
        </svg>
        <span
          class="tooltiptext absolute bg-gray-700 text-white rounded-md text-xs mt-6 -ml-10 tooltip-1-width"
          :class="{ 'hidden' : isTooltipHidden }"
          >Enter any reference for the booking, such as the sender's reference number or the receiver's
          reference number (often this is the purchase order number) or the Freighthub booking number. <br />
          These can be found in the booking email notification, on the
          consignment note or under ‘Bookings’ (when logged into your Freighthub
          account).
        </span>
      </div>
    </div>

    <div class="lg:flex">
      <div class="mt-4 lg:w-1/2 lg:mr-5">
        <div class="relative">
          <input
            class="form-input text-sm w-full py-4 pl-6"
            :class="[
              validation.bookingNumber ? passedField : '',
              !validationErrors && !validation.bookingNumber ? emptyField : '',
              validationErrors ? failedField : '',
            ]"
            @blur="checkBookingNumber()"
            @keyup="checkBookingNumber()"
            v-on:keyup.enter="submit"
            v-model="form.bookingID"
            type="text"
            placeholder="Enter your reference or booking number"
            v-validate="'required'"
            name="bookingId"
          />
          <div
            @click="submit"
            class="absolute right-0 top-0 bg-blue-400 hover:bg-blue-500 p-4 text-sm text-white rounded-md rounded-l-none cursor-pointer"
            style="padding-bottom:18px;"
          >
            search
          </div>
        </div>

        <!-- <div v-if="!bookingIsNumber" class="mt-2 text-xs text-red-400 pl-6">
          Please enter a numeric value
        </div> -->
      </div>

      <!-- <div class="mt-4 relative lg:w-1/2 lg:ml-5" v-if="notUnique">
        <div class="relative">
          <input
            onfocus="showHint()"
            onblur="hideHint()"
            id="address"
            class="form-input z-40 relative text-sm w-full py-4 pl-6"
            :class="[
              validation.address ? passedField : '',
              !validationErrors && !validation.address ? emptyField : '',
              validationErrors ? failedField : '',
            ]"
            type="text"
            placeholder="Delivery address: e.g. Forrest Hill Road"
            v-validate="'required'"
            v-model="form.streetName"
            name="streetName"
            @blur="checkDeliveryAddress()"
            v-on:keyup.enter="submit"
          />
          <div
            @click="checkDeliveryAddress"
            class="absolute right-0 top-0 bg-blue-400 hover:bg-blue-500 p-4 text-sm text-white rounded-md rounded-l-none cursor-pointer z-40"
            style="padding-bottom:18px;"
          >
            update
          </div>
        </div>

        <div
          id="address-hint"
          class="hidden relative -mt-4 text-xs text-orange-700 bg-orange-200 pl-3 pb-3 pt-6 rounded-b-md absolute w-full z-10"
        >
          Fill this in for more customer information about your freight
          <div class="tooltip">
            <svg
              class="inline-block fill-current h-4 -mt-1 ml-4 w-4 hover:text-orange-800"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.3431 13.657A8 8 0 1113.656 2.343 8 8 0 012.343 13.657zm10.19-1.123a6.401 6.401 0 10-9.069-9.036 6.401 6.401 0 009.069 9.036zM7.199 8.801v-1.6h1.6v4.8H7.2v-3.2zm0-4.8h1.6v1.6H7.2v-1.6z"
              />
            </svg>
            <span
              class="tooltiptext bg-gray-700 text-white rounded-md text-xs absolute mt-5 -ml-8 tooltip-2-width"
              >For security purposes we require a street name as well as your
              booking number to provide the full booking information.</span
            >
          </div>
        </div>
      </div> -->


    </div>
    <div
      v-if="bookingNumberError"
      class="mt-8 text-base text-left bg-red-100 border-l-4 border-red-500 text-red-700 p-4 relative w-full"
      role="alert"
    >
      <p>
        Sorry, the information you entered does not correspond to a valid
        booking.
      </p>
      <span
        @click="bookingNumberError = false"
        class="absolute top-0 bottom-0 right-0 px-4 py-3"
      >
        <svg
          class="fill-current h-6 w-6 mt-1 text-red-500"
          role="button"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <title>Close</title>
          <path
            d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
          />
        </svg>
      </span>
    </div>

    <div
      v-if="showHalfBooking && !showBooking"
      v-for="(trackingNumber, index) in trackingNumbers"
      :key="index"
    >
      <guest-bookings-details
        :trackingNumber="trackingNumber"
      ></guest-bookings-details>
    </div>

    <div 
      v-if="showBooking"
      v-for="(trackingNumber, index) in trackingNumbers"
      :key="index"
    >
      <guest-bookings-details
        :trackingNumber="trackingNumber"
        :showBooking="showBooking"
      ></guest-bookings-details>
    </div>

    <div
      v-if="smallLoading"
      class="text-blue-400 flex items-center justify-center mt-12"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-16 h-16"
        viewBox="0 0 100 100"
      >
        <path
          fill="currentColor"
          d="M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  </div>
</template>

<script>
import GuestBookingsDetails from "./GuestBookingDetails";
export default {
  name: "track-bookings",

  components: { GuestBookingsDetails },

  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      trackingNumbers: [],
      trackingUrl: "tracking/bookings/",
      showBooking: false,
      showHalfBooking: false,
      bookingID: "",
      loading: false,
      smallLoading: false,
      labelPosition: "top",
      form: {
        bookingID: "",
        streetName: "",
        reference: "",
      },
      isInput: false,
      notUnique: false,
      passedField: "bg-white border border-teal-400",
      failedField: "bg-white border border-red-500",
      emptyField: "bg-gray-200 focus:bg-white border border-gray-200",
      validation: {
        address: false,
        bookingNumber: false,
      },
      validationErrors: false,
      bookingNumberError: false,
      bookingIsNumber: true,
      isTooltipHidden: true,
    };
  },

  mounted() {
    if (this.getUrlParams.bookingId) {
      this.form.bookingID = this.getUrlParams.bookingId;
      this.submit();
    }
    this.isTooltipHidden = false;
  },

  methods: {
    validateForm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.submit();
        }
      });
    },

    submit() {
      this.validationErrors = false;
      this.validation.bookingNumber = true;
      this.smallLoading = true;
      this.loading = true;
      this.showBooking = false;
      axios
        .post("/track/getTrackingNumber", {
          bookingID: this.form.bookingID,
          streetName: this.form.streetName,
          reference: this.form.reference,
        })
        .then((res) => {
          if (res.data[0].length > 10) {
            this.trackingNumbers = res.data;
            if (this.form.streetName) {
              this.trackingNumbers = res.data;
              this.showBooking = true;
              this.validationErrors = false;
              this.validation.bookingNumber = true;
              this.loading = false;
              this.smallLoading = false;
              return;
            } else {
              this.loading = false;
              this.notUnique = true;
              this.showBooking = true;
              this.showHalfBooking = true;
              this.validationErrors = false;
              this.smallLoading = false;
              return;
            }
          }
        })
        .catch((error) => {
          this.bookingNumberError = true;
          this.validation.address = false;
          this.validation.bookingNumber = false;
          this.validationErrors = true;
          this.loading = false;
          this.smallLoading = false;
        });
    },
    checkBookingNumber() {
      if (this.bookingEntered) {
        this.smallLoading = true;
        if (!isNaN(this.form.bookingID)) {
          this.bookingIsNumber = true;
          this.validationErrors = false;
          this.validation.bookingNumber = true;
          this.validateForm();
        } else {
          this.bookingIsNumber = true;
          this.validationErrors = false;
          this.validation.bookingNumber = true;
          this.validateForm();
        }
      }
    },

    checkDeliveryAddress() {
      if (this.form.streetName.length > 1) {
        this.validation.address = true;
        this.validateForm();
      }
    },
  },
  computed: {
    bookingEntered: function() {
      if (this.form.bookingID.length >= 6) {
        return true;
      } else {
        return false;
      }
    },

    getUrlParams() {
      let uri = window.location.href.split("?");
      if (uri.length == 2) {
        let vars = uri[1].split("&");
        let getVars = {};
        let tmp = "";
        vars.forEach(function(v) {
          tmp = v.split("=");
          if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
        });
        return getVars;
      }

      return {};
    },
  },

  watch: {
    triggerForm: function() {
      if (this.bookingEntered) {
        this.validateForm();
      }
    },
  },
};
</script>
